import type { WorkflowRun } from '@/types'

export function canManageWorkflowRun(
  run: Pick<WorkflowRun, 'triggeredByUserId'>,
  currentUserId: string | undefined,
  isAdmin: boolean,
): boolean {
  if (isAdmin) return true
  return !!currentUserId && !!run.triggeredByUserId && currentUserId === run.triggeredByUserId
}
